var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Sidebar',{attrs:{"drawer":_vm.drawer}}),_c('Topbar',{on:{"drawerEvent":function($event){_vm.drawer = !_vm.drawer}}}),_c('v-main',{staticStyle:{"background":"#f5f5f540"}},[_c('v-container',{staticClass:"py-8 px-6",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }